import React, { useState, useEffect } from 'react';
import { ChevronDown } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const QUOTE_ID = 'SAMPLE';

const Accordion = ({ title, children, onOpen }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleToggle = () => {
        const next = !isOpen;
        setIsOpen(next);

        if (next && onOpen) {
            onOpen(title);
        }
    };
    return (
        <div className={`accordion ${isOpen ? "open" : ""}`}>
            <button className="accordion-trigger" onClick={handleToggle}>
                <h3>{title}</h3>
                <ChevronDown className={`accordion-icon ${isOpen ? "rotated" : ""}`} />
            </button>
            {isOpen && <>{children}</>}
        </div>
    );
};

export default function Quote_SAMPLE() {
    const navigate = useNavigate();
    const [input, setInput] = useState('');
    const [unlocked, setUnlocked] = useState(false);
    const [error, setError] = useState('');
    const [suppressNotifications, setSuppressNotifications] = useState('');

    const [quoteData, setQuoteData] = useState(null);

    useEffect(() => {
        fetch(`/api/quoteRoute/${QUOTE_ID}`)
            .then(r => r.json())
            .then(setQuoteData);
    }, []);

    const unlock = (suppressNotification = false, meta = {}) => {
        setUnlocked(true);
        setSuppressNotifications(suppressNotification);

        if (suppressNotification) return;

        fetch('/api/quoteRoute/viewed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                unlockMethod: meta.method,
                unlockValue: meta.value
            })
        }).catch(() => { });
    };

    const trackAccordionOpen = (sectionTitle) => {
        fetch('/api/quoteRoute/interaction', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                type: 'accordion_open',
                section: sectionTitle
            })
        }).catch(() => { });
    };

    if (!unlocked) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px', textAlign: 'center' }}>
                    <img src='/transparent-logo-min.png' alt='Logo' style={{ width: '100%', marginBottom: '1rem' }} />
                    <h2 style={{ marginBottom: '0.25rem' }}>Your Quote</h2>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>North Florida Home Repair & Maintenance</p>
                    <input
                        type="text"
                        placeholder="Enter your access code"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                const cleaned = input.replace(/\D/g, '') || input.trim();
                                const normalize = v => v?.replace(/\D/g, '') || v?.trim();

                                const phone1 = normalize(quoteData?.clientPhone);
                                const phone2 = normalize(quoteData?.clientPhone2);
                                const password = normalize(quoteData?.customPassword);

                                if (cleaned === '1131') {
                                    unlock(true, { method: 'override', value: cleaned });
                                } else if (cleaned === phone1) {
                                    unlock(false, { method: 'clientPhone', value: cleaned });
                                } else if (cleaned === phone2) {
                                    unlock(false, { method: 'clientPhone2', value: cleaned });
                                } else if (cleaned === password) {
                                    unlock(false, { method: 'customPassword', value: cleaned });
                                } else {
                                    setError('Incorrect. Try again.');
                                }
                            }
                        }}
                        style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box', marginBottom: '0.5rem' }}
                    />
                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>{error}</p>}
                    <button
                        onClick={() => {
                            const cleaned = input.replace(/\D/g, '') || input.trim();
                            const normalize = v => v?.replace(/\D/g, '') || v?.trim();

                            const phone1 = normalize(quoteData?.clientPhone);
                            const phone2 = normalize(quoteData?.clientPhone2);
                            const password = normalize(quoteData?.customPassword);

                            if (cleaned === '1131') {
                                unlock(true, { method: 'override', value: cleaned });
                            } else if (cleaned === phone1) {
                                unlock(false, { method: 'clientPhone', value: cleaned });
                            } else if (cleaned === phone2) {
                                unlock(false, { method: 'clientPhone2', value: cleaned });
                            } else if (cleaned === password) {
                                unlock(false, { method: 'customPassword', value: cleaned });
                            } else {
                                setError('Incorrect. Try again.');
                            }
                        }}
                        style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.65rem 1.25rem', fontSize: '0.95rem', cursor: 'pointer', width: '100%' }}
                    >
                        View quote
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className='app'>
            <main className='page' style={{ paddingTop: 0 }}>
                <section className='section section-about'>
                    <div className='hero'>
                        <img src='/jax_small.jpg' alt='Logo' className='hero-image' />
                        <div className='hero-overlay'>
                            <div className='hero-text-box'>
                                <div className='hero-title-main'>North Florida</div>
                                <div className='hero-title-sub'>Home Repair & Maintenance</div>
                            </div>
                        </div>
                    </div>

                    <div className='custom-quote'>
                        <div className="quote-subsection" style={{ borderBottom: '2px solid #111827' }}>
                            <p>Thank you again for the opportunity to review your project. I've gone through the details and prepared the information below.</p>
                            <p>As promised, you'll find a breakdown of the quoted work. I've included notes where helpful to provide additional context around certain items.</p>
                            <p>The scope of work is outlined below. If the project includes multiple components, they are presented separately so you can move forward with any portion at your discretion. When you're ready to proceed, I can provide a formal quote for approval.</p>
                        </div>

                        {/* <Accordion title="TITLE" onOpen={trackAccordionOpen}>
                        </Accordion> */}
                        <div className="quote-section">
                            <div className='quote-subsection'>
                                <div className="project-description">
                                    This project involves...
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Scope of work</h3>
                                <div className="white-card">
                                    <ul className="scope-list">
                                        <li><strong>Site Prep & Dust Mitigation:</strong> Reroute surface-mounted EMT conduit. Establish heavy-duty poly-sheeting barriers to contain masonry dust and slurry during the cutting phase.</li>
                                    </ul>
                                    <div className="time-expectation"><strong>Time expectation:</strong> 2 days (18-20 hours) for two windows. 3 days (24-26 hours) if doing all three.</div>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Sizing Strategy</h3>
                                <div className="white-card">
                                    <div className="white-card-comment">
                                        To keep labor costs down and the installation clean, I have planned these openings for <strong>32" width</strong>. This allows us to remove exactly two full blocks per course, lining up perfectly with the vertical mortar joints. This prevents the need for hundreds of small vertical cuts and maintains the highest possible structural integrity of the surrounding wall.
                                    </div>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Materials estimate</h3>
                                <div className="white-card">
                                    <ul className="material-card-list">
                                        <li><strong>14" Masonry Saw Rental:</strong> $150</li>
                                        <li><strong>Bedroom Windows:</strong> <a href="https://www.homedepot.com/p/American-Craftsman-31-75-in-x-45-25-in-70-Pro-Series-Low-E-Argon-Glass-Double-Hung-White-Vinyl-Replacement-Window-Screen-Incl-3246786/204814582" target="_blank">$600 for both</a></li>
                                        <li><strong>Procurement & delivery:</strong> $50</li>
                                    </ul>
                                </div>
                                <div className="material-note">All materials are billed at exact cost, and copies of all receipts will be provided for your records. <strong>Procurement & delivery fee</strong> covers the professional selection of quality materials, time spent at suppliers, fuel, and the logistics of transporting materials to the job site.</div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Pricing</h3>
                                <div className="quote-pricing-block">
                                    Two bedroom windows only
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate):</span>
                                        <span className="pricing-value">$2,000</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials (estimated):</span>
                                        <span className="pricing-value">~$1,000</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Estimated total:</span>
                                        <span className="pricing-value">$3,000</span>
                                    </div>
                                </div>
                                <div className="quote-pricing-block">
                                    All 3 windows discussed
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate):</span>
                                        <span className="pricing-value">$2,600</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials (estimated):</span>
                                        <span className="pricing-value">~$1,240</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Estimated total:</span>
                                        <span className="pricing-value">$3,840</span>
                                    </div>
                                </div>
                                <div className="pricing-note">Labor rate includes all structural shoring, masonry demolition, and professional installation.
                                </div>
                            </div>

                        </div>

                        <hr style={{ marginTop: '3rem' }} />
                        <h2>Next Steps</h2>
                        <p>
                            Estimates provided are valid for 30 days. For any project that requires a material order above $500, a deposit covering material costs is required prior to scheduling. Labor is due upon completion of the work.
                        </p>
                        <p>
                            <strong>Please reach out</strong> whenever you are ready to move forward or if you have any questions!
                        </p>
                    </div>
                </section>
            </main>
            <footer className="quote-footer">
                <h1>Thank you!</h1>
                <div className="footer-brand-box">
                    <img
                        src="/transparent-logo-min.png"
                        alt="North Florida Home Repair & Maintenance"
                        className="footer-logo"
                    />
                    <div className="footer-fine-print">
                        Reliable | Insured | Professional Home Services
                    </div>
                </div>
                <div className="footer-contact-info">
                    <a href="tel:9043862663" className="contact-link">
                        (904) 386-2663
                    </a>
                    <span className="contact-divider">•</span>
                    <a href="mailto:daniel@northfloridarepair.com" className="contact-link">
                        daniel@northfloridarepair.com
                    </a>
                </div>

                <div className="footer-actions">
                    <button onClick={() => navigate('/')} className='home-button'>
                        ← Return Home
                    </button>
                </div>
            </footer>
        </div>
    );
}